import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import en from './en.json'
import fr from './fr.json'
import zh_cn from './zh-cn.json'
import zh_hk from './zh-hk.json'

import en2 from './app/en.json'
import fr2 from './app/fr.json'
import zh_cn2 from './app/zh-cn.json'
import zh_hk2 from './app/zh-hk.json'

const defaultLocale = 'en'

const languages = {
  en: { ...en, ...en2 },
  fr: {...fr, ...fr2},
  "zh-cn": {...zh_cn, ...zh_cn2},
  "zh-hk": {...zh_hk, ...zh_hk2},  
}

const messages = Object.assign(languages);
export default new VueI18n({
  locale: defaultLocale,
  messages: messages,
  silentTranslationWarn: true,
  fallbackLocale: "en",  
});